import { useLoadedData } from "../../../toolympus/hooks/useLoadedData"
import { FieldType, Schema } from "../../../toolympus/hooks/useSchema";
import { EventRegistration, EventRegistrationSchema } from "../Calendar/useEventRegistrations"
import { CalendarEvent } from "../Calendar/useEventsAdminList";

type AttendeeRegistration = EventRegistration & Pick<CalendarEvent, "title" | "title_ru" | "start_datetime">;

const AttendeeRegistrationSchema: Schema = {
  ...EventRegistrationSchema,
  title: { label: "Event" },
  start_datetime: { label: "Date", type: FieldType.datetime },
}

export const useAttendeeRegistrations = (attendeeId: string) => {
  const data = useLoadedData<AttendeeRegistration[]>(`/api/registration/admin/attendee/${attendeeId}`, [], !!attendeeId);

  return {
    ...data,
    schema: AttendeeRegistrationSchema,
  }
}
